import axios from 'axios';
import { TokenUtil } from 'services/TokenUtil';

export const refreshAccessToken = async (refresh_token: string): Promise<string> => {
  const customer = TokenUtil.getAccessTokenCustomer()?.id;
  const tokenData = await axios.post<{ token: string; refresh_token: string }>(
    `${BACKEND_URL}/tokens/refresh`,
    { customer, refresh_token }
  );
  return tokenData.data.token;
};
